module.exports = __webpack_public_path__ + "f219e20e8aed5cb8efe3fa43932223d6.svg";